import Link from 'next/link';
import { footerDataKinhDoanh } from '../footerData';
import ListLink from './ListLink';

export default function NavigateFooterKinhDoanh() {
  return (
    <div className="desktop:mt-6 desktop:grid-cols-6 grid grid-cols-2 gap-6">
      {/* style below div in 2 col */}
      <div className="desktop:col-span-2 col-span-2">
        <Link href="/">
          <h3 className="text-body16 text-neutral-90 desktop:text-subtitle20 text-left font-bold">
            Kinhdoanh.ahamove
          </h3>
        </Link>

        <p className="text-body14 text-neutral-90 desktop:text-body16 max-w-sm">
          Kinhdoanh.ahamove là cẩm nang khởi nghiệp toàn diện, nơi chia sẻ kiến
          thức kinh doanh từ tìm ý tưởng, mở cửa hàng, tìm nguồn hàng đến các
          giải pháp bán hàng hiệu quả dành cho người mới bắt đầu.
        </p>
      </div>
      {footerDataKinhDoanh.map((item) => (
        <ListLink
          items={item.items}
          href={item.href}
          title={item.title}
          key={item.id}
          isExtraPage
        />
      ))}
    </div>
  );
}
